import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';

const DayOfWeekNameContainer = styled.div`
    width: 40px;
    height: 40px;
    padding: ${theme.space[8]};
    text-align: center;
`;

interface DayOfWeekNameProps {
    children: string;
}

export const DayOfWeekName = ({ children }: DayOfWeekNameProps) => {
    return (
        <DayOfWeekNameContainer>
            <Text variant="small" fontWeight={600}>
                {children.slice(0, 2)}
            </Text>
        </DayOfWeekNameContainer>
    );
};
